
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-contact",
      function () {
        return require("private-next-pages/why-contact/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-contact"])
      });
    }
  